'use client'

import type { ProductColor } from 'product/types'
import { ColorSelectorPicker } from 'product-components/components/ColorSelector/ColorSelectorPicker/ColorSelectorPicker'
import { useCallback } from 'react'
import { cx } from 'utils/cx'
import styles from './GroupedColorsButton.module.scss'

export interface OnClickGroupedColorsButtonProps {
	readonly colorId: string
	readonly relatedProductId: string | undefined
}

export interface GroupedColorsButtonProps {
	readonly color: ProductColor
	readonly dataTestId?: string
	readonly extraColors: number
	readonly onClick: (props: OnClickGroupedColorsButtonProps) => void
}
export function GroupedColorsButton({
	color,
	dataTestId,
	extraColors,
	onClick,
}: GroupedColorsButtonProps) {
	const { id, relatedProductId, bulletImg, label } = color

	const handleClick = useCallback(() => {
		onClick({
			colorId: id,
			relatedProductId,
		})
	}, [id, relatedProductId, onClick])

	return (
		<button
			type='button'
			className={cx(styles.colorButton)}
			data-testid={dataTestId}
			onClick={handleClick}
		>
			<ColorSelectorPicker
				imageAlt={label}
				imageSrc={bulletImg}
				extraColors={extraColors}
			/>
		</button>
	)
}
